import { create } from 'zustand';
import { PaymentMethodStore } from '../types/shopping';
import { MethodWay } from '../utils/common';

const usePaymentMethodStore = create<PaymentMethodStore>((set) => ({
  paymentMethod: MethodWay.BC,
  setPaymentMethod: (method) => set({ paymentMethod: method }),
}));

export default usePaymentMethodStore;
